import STATIC from "./constant/index";

import kc from "../keycloak";

const axios = require("axios");

export interface dataWithToken {
  url: string;
  data: any;
  token?: any;
}
/**
 * @param arg string type request
 * @param token optionelle token parametre
 * @returns {object} object header with token
 */
const headers = (arg = "application/json", token = "") => ({
  "Content-Type": arg,
  Authorization: `Bearer ${token}`,
  Accept: "application/json",
});

/**
 * @param arg string type request
 * @returns {object} object header without token
 */
const headerWithoutToken = (arg = "application/json") => ({
  "Content-Type": arg,
  Accept: "application/json",
});

/***
 *@returns instance of axios
 */
const axiosProvider = axios.create({
  // Dev #47679 V1 Agrandir la taille max de la video dans company page
  timeout: 1200000,
  baseURL: STATIC.baseUrl,
});

axiosProvider.interceptors.request.use(async (config: any) => {
  console.log('configconfigconfigconfigconfigconfig', config)
  try {
    await kc.updateToken(5);
    if (kc?.token) {
      config.headers.Authorization = `Bearer ${kc?.token}`;
    }
  } catch (error) {
    console.warn("Erreur lors de la récupération du token depuis le store:", error);
  }
  return config;
});

let isRefreshing = false;

let failedQueue: { resolve: Function; reject: Function }[] = [];


const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(request => {
    if (error) {
      request.reject(error);
    } else {
      request.resolve(token);
    }
  });
  failedQueue = [];
};


// Response interceptor for API calls
axiosProvider.interceptors.response.use(
  (response: any) => {
    return response;
  },
  async (error: any) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // Si un refresh est déjà en cours, on met la requête en file d'attente
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axiosProvider(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        if (kc.isTokenExpired()) {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          // Force la redirection vers la page de login de Keycloak
          kc.login();
          return
        }

        const refreshed = await kc.updateToken(50);

        if (refreshed) {
          console.log("Token rafraîchi avec succès");

          // On met à jour le token dans la requête originale
          originalRequest.headers.Authorization = `Bearer ${kc.token}`;

          // On traite la file d'attente avec le nouveau token
          processQueue(null, kc.token);
        } else {
          console.log("Token toujours valide");
          processQueue(null, kc.token);
        }

        isRefreshing = false;

        // On réessaie la requête originale avec le nouveau token
        return axiosProvider(originalRequest);
      } catch (refreshError) {
        console.error("Échec du rafraîchissement du token", refreshError);

        // Si le refresh échoue, on nettoie et on rejette toutes les requêtes en attente
        processQueue(refreshError);

        // On nettoie les tokens
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');

        // Force la redirection vers la page de login de Keycloak
        kc.login();

        isRefreshing = false;
        return Promise.reject(error);
      }
    }

    // Pour toute autre erreur, on rejette simplement
    return Promise.reject(error);
  }
);


/***
 *@returns instance of axios
 */
const axiosMicroserviceProvider = axios.create({
  // Dev #47679 V1 Agrandir la taille max de la video dans company page
  timeout: 1200000,
  baseURL: STATIC.microserviceUrl,
});

/***
 *@returns instance of axios
 */
const axiosStaticDataProvider = axios.create({
  // Dev #47679 V1 Agrandir la taille max de la video dans company page
  timeout: 1200000,
  baseURL: STATIC.staticDataUrl,
});

/**
 * @param data data to send
 * @param argument of data to check if form data or string
 */
export const datas = (data: any, arg = "application/json") => {
  if (arg === "application/json") {
    return JSON.stringify(data);
  } else if (arg === "multipart/form-data") {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    return formData;
  } else {
    return data;
  }
};

/**
 * @param url string url to call api post
 * @param data object to send
 * @param token token to send
 * @returns result of post response
 */
export const postData = async (url: string, data: any, token: any) => {
  try {
    const result = await axiosProvider({
      method: "POST",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: JSON.stringify(data),
    });
    return result;
  } catch (exception: any) {
    // if (window.location.href.includes('reply-post')) window.location.href = '/';
  }
};

export const asyncPostData = (url: string, data: any, token: any) => {
  return axiosProvider({
    method: "POST",
    url: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: JSON.stringify(data),
  });
};

export const patchData = async (url: string, data: any, token: any) => {
  const result = await axiosProvider({
    method: "PATCH",
    url: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: JSON.stringify(data),
  });
  return result;
};
/**
 * @param url string url to call api post
 * @param token token to send
 * @returns result of get response
 */
export const getData = async (url: string, token: any) => {
  try {
    const result = await axiosProvider({
      method: "get",
      url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return result;
  } catch (e: any) {
    return e.response;
  }
};
/**
 * @param params object to send
 * @returns result of get response
 */
export const putData = async (params: dataWithToken) => {
  try {
    const result = axiosProvider({
      method: "put",
      url: params.url,
      data: params.data,
      headers: {
        Authorization: `Bearer ${params.token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return result;
  } catch (e: any) {
    return null;
  }
};

export const deleteData = async (params: dataWithToken) => {
  try {
    return axiosProvider({
      method: "delete",
      url: params.url,
      headers: {
        Authorization: `Bearer ${params?.token}`,
        "Content-Type": "text/plain",
        Accept: "application/json",
      },
    });
  } catch (e: any) {
    return e;
  }
};

export const deleteWithToken = async (params: dataWithToken) => {
  try {
    const result = axiosProvider({
      method: "delete",
      url: params?.url,
      data: params?.data,
      headers: {
        Authorization: `Bearer ${params?.token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return result;
  } catch (e: any) {
    return null;
  }
};

export const putPhoto = async (params: dataWithToken, arg: any) => {
  try {
    const result = await axiosProvider({
      method: "put",
      url: params.url,
      data: datas(params?.data, arg),
      headers: headers(arg, params.token),
    });
    return result;
  } catch (e: any) {
    return null;
  }
};

// Dev #47679 OPEN V1 Agrandir la taille max de la video dans company page
export const postPhoto = async (
  params: dataWithToken,
  token: string = "",
  callBackProgression: any = null
) => {
  try {
    const result = await axiosProvider({
      method: "POST",
      url: params.url,
      data: datas(params.data, "multipart/form-data"),
      headers: headers("multipart/form-data", token),
      onUploadProgress: (progressEvent: any) => {
        console.log("onUploadProgress", progressEvent);
        if (callBackProgression !== null) callBackProgression(progressEvent);
      },
    });
    return result;
  } catch (error) {
    return error;
  }
};

export const asyncPostPhoto = (
  params: FormData,
  url: string,
  token: string = "",
  callBackProgression: any = null
) => {
  return axiosProvider({
    method: "POST",
    url: url,
    data: params,
    headers: headers("multipart/form-data", token),
    onUploadProgress: (progressEvent: any) => {
      if (callBackProgression !== null) callBackProgression(progressEvent);
    },
  });
};

export const postWithoutToken = async (url: string, data: any, arg?: any) => {
  try {
    const result = await axiosProvider({
      method: "post",
      url: url,
      data: data,
      headers: headerWithoutToken(),
    });
    return result;
  } catch (error: any) {
    return error?.response;
  }
};

export const postWithoutTokenCombineUrl = async (
  url: string,
  param: string
) => {
  return axiosProvider({
    method: "post",
    url: `${url}/${param}`,
    headers: headerWithoutToken(),
  });
};

export const getDataWithoutToken = async (
  url: string,
  data?: any,
  token?: string
) => {
  return axiosProvider({
    method: "get",
    url,
    headers: headers("application/json", token),
    params: data,
  });
};

export const getMicroserviceDataWithToken = (
  url: string,
  data?: any,
  token?: string
) => {
  return axiosMicroserviceProvider({
    method: "get",
    url,
    headers: headers("application/json", token),
    params: data,
  });
};

export const getStaticDataWithToken = (
  url: string,
  data?: any,
  token?: string
) => {
  return axiosStaticDataProvider({
    method: "get",
    url,
    headers: headers("application/json", token),
    params: data,
  });
};

export const deleteMicroserviceDataWithToken = (
  url: string,
  data?: any,
  token?: string
) => {
  return axiosMicroserviceProvider({
    method: "delete",
    url,
    headers: headers("application/json", token),
    params: data,
  });
};

export const postMicroserviceDataWithToken = (
  url: string,
  data?: any,
  token?: string
) => {
  return axiosMicroserviceProvider({
    method: "post",
    url,
    headers: headers("application/json", token),
    data: data,
  });
};

export const getDataMicroService = (
  url: string,
  data?: any,
  token?: string
) => {
  return axiosMicroserviceProvider({
    method: "get",
    url,
    headers: headers("application/json", token),
    params: data,
  });
};

export const getDataParam = async (url: string, data?: any, token?: string) => {
  return axiosProvider({
    method: "get",
    url,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    params: data,
  });
};

export const detectBrowser = () => {
  const userAgent = navigator.userAgent;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "Chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "Firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "Safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "Opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "Edge";
  } else if (userAgent.match(/trident/i)) {
    browserName = "Internet Explorer";
  } else {
    browserName = "Navigateur inconnu";
  }

  return browserName;

}

//https://www.smashingmagazine.com/2020/05/typescript-modern-react-projects-webpack-babel/
